import { Container, Grid, SectionText } from '@/atoms';
import { Card } from '@/molecules';

import type { TypeTextColorVariant } from '@/components/types';
import type { FunctionComponent } from 'react';
import type { TypeSustainabilityProps } from './types';

const VARIANT_MAPS: Record<TypeTextColorVariant, string> = {
  primary: 'text-primary-400',
  secondary: 'text-secondary-400',
  alternative: 'text-white',
};

/**
 * Sustainability
 */
export const Sustainability: FunctionComponent<TypeSustainabilityProps> = ({
  className = '',
  backgroundColorBottom,
  backgroundColorBottomMobile,
  backgroundColorTop,
  backgroundColorTopMobile,
  caption,
  cards,
  cardtitle,
  cutLevel = 50,
  cutLevelMobile = 50,
  description,
  textColor,
  title,
  index,
  id,
}: TypeSustainabilityProps) => (
  <Container
    backgroundColorBottom={backgroundColorBottom}
    backgroundColorTopMobile={backgroundColorTopMobile}
    backgroundColorTop={backgroundColorTop}
    backgroundColorBottomMobile={backgroundColorBottomMobile}
    cutLevel={cutLevel === null ? 50 : cutLevel}
    cutLevelMobile={cutLevelMobile === null ? 50 : cutLevel}
    className={`flex flex-col gap-10 ${className}`}
    index={index}
    id={id}
  >
    <SectionText
      title={title}
      desc={description}
      direction="row"
      textAlign="start"
      variant={textColor}
      caption={caption}
    />
    <div className={`flex flex-col gap-5 ${VARIANT_MAPS[textColor]} `}>
      <h3 className="text-heading text-heading--h3">{cardtitle}</h3>
      <Grid className="!gap-5">
        {cards.map((card, index: number) => (
          <Grid.Item key={index}>
            <Card
              multimediaProps={{ image: card.image }}
              backgroundColor={card.backgroundColor}
              className="h-full"
            >
              <div className="flex flex-col gap-3">
                <h4 className="text-heading text-heading--h4">{card.title}</h4>
                <span className="text-body text-body--primary">
                  {card.description}
                </span>
              </div>
            </Card>
          </Grid.Item>
        ))}
      </Grid>
    </div>
  </Container>
);

Sustainability.displayName = 'Sustainability';
